import React from "react";
import { Accordion } from "react-bootstrap";
import { imgUrl } from "../config/api";

export default function GuestProductList({
  productGuest,
  pageLanguage,
  NumberToPersianWord,
  convertToPersian,
  t,
  GetPrice,
  isTabletOrMobile,
  ContextAwareToggleViewDetails,
  capitalizeFirstLetter,
}) {
  return (
    <div>
      {productGuest.length > 0 &&
        [...productGuest]
          .filter((item) => item.TypeId !== 6402)
          .sort(
            (a, b) =>
              (b.CartDetailId ?? 0) - (a.CartDetailId ?? 0) ||
              (b.SewingOrderId ?? 0) - (a.SewingOrderId ?? 0)
          )
          .map((product, i) => (
            <li className="checkout_item_container" key={i}>
              <div className="checkout_item_image_container">
                {product.TypeId === 6401 ? (
                  <img
                    src={imgUrl(product.PhotoUrl)}
                    alt={product.ProductName}
                    className="checkout_item_img"
                  />
                ) : (
                  <img
                    src={imgUrl(product.SewingOrder.PreorderText.PhotoUrl)}
                    alt=""
                    className="checkout_item_img"
                  />
                )}
                <p className="checkout_item_image_qty">
                  {pageLanguage === "fa"
                    ? NumberToPersianWord.convertEnToPe(`${product.Count}`)
                    : product.Count}
                </p>
              </div>
              <div className="checkout_item_desc_container 2">
                <div className="checkout_item 2">
                  <h1 className="checkout_item_name">
                    {product.TypeId === 6401 ? (
                      <>
                        {pageLanguage === "fa" ? product.ProductDesignName : product.ProductEnName}
                      </>
                    ) : (
                      <>
                        {pageLanguage === "fa"
                          ? convertToPersian(product.SewingOrder.PreorderText.ModelNameFa) +
                            " سفارشی "
                          : "Custom " + product.SewingOrder.PreorderText.ModelNameEn}
                      </>
                    )}
                  </h1>
                  {product.TypeId === 6401 ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        className="checkout_item_price"
                        style={{
                          textDecoration:
                            product.Amount !== product.PayableAmount ? "line-through" : "none",
                        }}
                      >
                        {product.Amount === 0
                          ? t("Free")
                          : GetPrice(
                              product.Amount * product.Count,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                      </span>
                      {product.Amount !== product.PayableAmount && (
                        <span className="checkout_item_price" style={{ color: "#ca6667" }}>
                          {product.PayableAmount === 0
                            ? t("Free")
                            : GetPrice(
                                product.PayableAmount * product.Count,
                                pageLanguage,
                                t("TOMANS"),
                                isTabletOrMobile
                              )}
                        </span>
                      )}
                    </div>
                  ) : (
                    <div className="checkout_item_price_section 2">
                      {product.Amount !== product.PayableAmount ? (
                        <>
                          <span
                            className="checkout_item_price checkout_item_price_with_discount"
                            style={{ textDecoration: "line-through" }}
                          >
                            {GetPrice(
                              product.Amount * product.Count,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </span>
                          <span className="checkout_item_price" style={{ color: "#ca6667" }}>
                            {GetPrice(
                              product.PayableAmount * product.Count,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </span>
                        </>
                      ) : (
                        <span className="checkout_item_price">
                          {GetPrice(
                            product.Amount * product.Count,
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )}
                        </span>
                      )}

                      {product?.SewingOrder?.PreorderText?.DiscountedPrice != null &&
                        product?.SewingOrder?.PreorderText?.DiscountedPrice !== 0 &&
                        product?.SewingOrder?.PreorderText?.DiscountedPrice !==
                          NaN(
                            <span className="checkout_item_price">
                              {GetPrice(
                                product?.SewingOrder?.PreorderText?.DiscountedPrice * product.Count,
                                pageLanguage,
                                t("TOMANS"),
                                isTabletOrMobile
                              )}
                            </span>
                          )}
                    </div>
                  )}
                </div>
                <>
                  {product.TypeId === 6403 ? (
                    <>
                      <h4 className="checkout_item_room_name">
                        {pageLanguage === "fa"
                          ? product.SewingOrder.PreorderText.RoomNameFa +
                            " / " +
                            product.SewingOrder.WindowName
                          : product.SewingOrder.PreorderText.RoomNameEn +
                            " / " +
                            product.SewingOrder.WindowName}
                      </h4>
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <ContextAwareToggleViewDetails
                            eventKey="0"
                            textOnHide={t("View Details")}
                            textOnShow={t("Hide Details")}
                          />
                          <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                            <div className="basket_item_title_container 13">
                              {product.SewingOrder.PreorderText.SewingModelId === "0099" && (
                                <h1 class="cart_agree_item_fabrics_sorted_title">
                                  {t("General Details")}
                                </h1>
                              )}
                              {product.SewingOrder.PreorderText.MountPositionId &&
                                product.SewingOrder.PreorderText.SewingModelId !== "0099" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Mount Position")}</p>
                                    <span>
                                      {product.SewingOrder.PreorderText.MountPositionId ===
                                        4802 && <span>{t("Inside Mount")}</span>}
                                      {product.SewingOrder.PreorderText.MountPositionId ===
                                        4801 && <span>{t("Outside Mount")}</span>}
                                      {product.SewingOrder.PreorderText.MountPositionId ===
                                        4803 && <span>{t("Moulding Mount")}</span>}
                                    </span>
                                  </div>
                                )}

                              {product.SewingOrder.PreorderText.MountPositionId &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Mount Position")}</p>
                                    <span>
                                      {product.SewingOrder.PreorderText.MountPositionId ===
                                        4801 && <span>{t("Ceiling")}</span>}
                                      {product.SewingOrder.PreorderText.MountPositionId ===
                                        4802 && <span>{t("Wall")}</span>}
                                      {product.SewingOrder.PreorderText.MountPositionId ===
                                        4803 && <span>{t("Moulding")}</span>}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.CurtainPositionId &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Curtain Position")}</p>
                                    <span>
                                      {product.SewingOrder.PreorderText.CurtainPositionId ===
                                        4901 && <span>{t("Standard")}</span>}
                                      {product.SewingOrder.PreorderText.CurtainPositionId ===
                                        4902 && <span>{t("Wall To Wall")}</span>}
                                      {product.SewingOrder.PreorderText.CurtainPositionId ===
                                        4903 && <span>{t("Right Corner Window")}</span>}
                                      {product.SewingOrder.PreorderText.CurtainPositionId ===
                                        4904 && <span>{t("Left Corner Window")}</span>}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.WindowWidth && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("WIDTH")}</p>
                                  <span>
                                    {pageLanguage === "fa" ? (
                                      <>
                                        {new Intl.NumberFormat("fa-IR").format(
                                          product.SewingOrder.PreorderText.WindowWidth
                                        )}
                                      </>
                                    ) : (
                                      <>{product.SewingOrder.PreorderText.WindowWidth}</>
                                    )}
                                    <>{t("cm")}</>
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.WindowHeight && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Height")}</p>
                                  <span>
                                    {pageLanguage === "fa" ? (
                                      <>
                                        {new Intl.NumberFormat("fa-IR").format(
                                          product.SewingOrder.PreorderText.WindowHeight
                                        )}
                                      </>
                                    ) : (
                                      <>{product.SewingOrder.PreorderText.WindowHeight}</>
                                    )}
                                    <>{t("cm")}</>
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.FinishedLengthTypeId &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Curtain Position")}</p>
                                    <span>
                                      {product.SewingOrder.PreorderText.FinishedLengthTypeId ===
                                        5401 && <span>{t("Sill")}</span>}
                                      {product.SewingOrder.PreorderText.FinishedLengthTypeId ===
                                        5402 && <span>{t("Apron")}</span>}
                                      {product.SewingOrder.PreorderText.FinishedLengthTypeId ===
                                        5403 && <span>{t("Floor")}</span>}
                                      {product.SewingOrder.PreorderText.FinishedLengthTypeId ===
                                        5404 && <span>{t("Slight Puddle")}</span>}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.SewingModelId === "0099" &&
                                (product.SewingOrder.PreorderText.FabricDesignEn ||
                                  product.FabricDesignEn) && (
                                  <div style={{ marginTop: "0.5rem" }}>
                                    <hr />
                                    <h1
                                      class="cart_agree_item_fabrics_sorted_title"
                                      style={{ marginTop: "0.2rem" }}
                                    >
                                      {t("Drapery")}
                                    </h1>
                                  </div>
                                )}

                              {product.SewingOrder.PreorderText.FabricDesignEn &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Material & Color")}</p>
                                    <span style={{ direction: "ltr" }}>
                                      {pageLanguage === "fa"
                                        ? product.SewingOrder.PreorderText.FabricDesignFa +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorFa
                                        : capitalizeFirstLetter(
                                            product.SewingOrder.PreorderText.FabricDesignEn
                                          ) +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorEn}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.BorderOrTrimDesignEn && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Decorative Border")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? `${product.SewingOrder.PreorderText.BorderOrTrimDesignFa}/${
                                          product.SewingOrder.PreorderText.BorderOrTrimColorFa
                                        }/${
                                          product.SewingOrder.PreorderText.borderPosition ===
                                          "60cm bottom border"
                                            ? "حاشیه۶۰ سانتی پایین"
                                            : product.SewingOrder.PreorderText.borderPosition
                                        }`
                                      : `${product.SewingOrder.PreorderText.BorderOrTrimDesignEn}/${product.SewingOrder.PreorderText.BorderOrTrimColorEn}/${product.SewingOrder.PreorderText.borderPosition}`}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.Lining && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Lining")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Unlined: "بدون خط",
                                          "Standard Lining": "آستردوزی استاندارد",
                                          Right: "راست",
                                          "Privacy Lining": "آستردوزی ضخیم",
                                        }[product.SewingOrder.PreorderText.Lining] ||
                                        product.SewingOrder.PreorderText.Lining
                                      : product.SewingOrder.PreorderText.Lining}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.PanelCoverage &&
                                (product.SewingOrder.PreorderText.FabricDesignEn ||
                                  product.FabricDesignEn) && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Panel Coverage")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            Full: "پوششی",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            Decorative: "دکوری",
                                          }[product.SewingOrder.PreorderText.PanelCoverage] ||
                                          product.SewingOrder.PreorderText.PanelCoverage
                                        : product.SewingOrder.PreorderText.PanelCoverage}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.PanelTypeA && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Panel Type")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          "Single Panel": "تک پنل، سمت چپ",
                                          "Standard Lining": "آستردوزی استاندارد",
                                          "Pair, Split Draw": "جفت پنل،دو طرف",
                                          "Single Panel, Right": "تک پنل، سمت راست",
                                        }[product.SewingOrder.PreorderText.PanelTypeA] ||
                                        product.SewingOrder.PreorderText.PanelTypeA
                                      : product.SewingOrder.PreorderText.PanelTypeA}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.GrommetFinish &&
                                (product.SewingOrder.PreorderText.FabricDesignEn ||
                                  product.FabricDesignEn) && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Grommet Finish")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "Satin Brass": "طلایی خش‌دار",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "Satin Nickel": "نقره‌ای خش‌دار",
                                            "Gun Metal": "دودی صیقلی",
                                          }[product.SewingOrder.PreorderText.GrommetFinish] ||
                                          product.SewingOrder.PreorderText.GrommetFinish
                                        : product.SewingOrder.PreorderText.GrommetFinish}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.hardwareDrapery &&
                                product.SewingOrder.PreorderText.hardwareDrapery !== "None" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Hardware")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
                                            "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "I Have Others": "من چیز دیگری دارم",
                                            "I Have Motorized Track": "من تراک موتوری دارم",
                                            "I Have Track With Cord Draw": "من تراک اتومات دارم",
                                            "I Have Standard Track": "من تراک استاندارد دارم",
                                          }[product.SewingOrder.PreorderText.hardwareDrapery] ||
                                          product.SewingOrder.PreorderText.hardwareDrapery
                                        : product.SewingOrder.PreorderText.hardwareDrapery}
                                    </span>
                                  </div>
                                )}

                              {(product.SewingOrder?.PreorderText?.DraperyHardware ||
                                product.SewingOrder?.PreorderText?.RailDesignFaA ||
                                product.SewingOrder?.PreorderText?.RailColorFaA ||
                                product.SewingOrder?.PreorderText?.BatonOptionA) &&
                                product.SewingOrder.PreorderText.DraperyHardware !== "None" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Hardware")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
                                            "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "I Have Others": "من چیز دیگری دارم",
                                            "I Have Motorized Track": "من تراک موتوری دارم",
                                            "I Have Standard Track": "من تراک استاندارد دارم",
                                            "I Have Track With Cord Draw": "من تراک اتومات دارم",
                                          }[product.SewingOrder.PreorderText.DraperyHardware] ||
                                          (product.SewingOrder.PreorderText.DraperyHardware ===
                                          "Rod"
                                            ? "میله پردهِ"
                                            : product.SewingOrder.PreorderText.DraperyHardware ===
                                              "Ring"
                                            ? "رینگ"
                                            : product.SewingOrder.PreorderText.DraperyHardware) +
                                            "/" +
                                            product.SewingOrder.PreorderText.RailDesignFaA +
                                            "/" +
                                            product.SewingOrder.PreorderText.RailColorFaA +
                                            "/" +
                                            (product.SewingOrder.PreorderText.BatonOptionA ===
                                            "Baton 45cm"
                                              ? "باتون ۴۵ س‌م"
                                              : product.SewingOrder.PreorderText.BatonOptionA ===
                                                "Baton 30cm"
                                              ? "باتون ۳۰ س‌م"
                                              : product.SewingOrder.PreorderText.BatonOptionA)
                                        : product.SewingOrder.PreorderText.DraperyHardware +
                                          "/" +
                                          product.SewingOrder.PreorderText.RailDesignEnA +
                                          "/" +
                                          product.SewingOrder.PreorderText.RailColorEnA +
                                          "/" +
                                          product.SewingOrder.PreorderText.BatonOptionA}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.HandCurtainNum && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Matching Tieback")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? `تعداد ${new Intl.NumberFormat("fa-IR").format(
                                          product.SewingOrder.PreorderText.HandCurtainNum
                                        )}`
                                      : `Qty ${product.SewingOrder.PreorderText.HandCurtainNum}`}
                                  </span>
                                </div>
                              )}

                              {product.SewingOrder.PreorderText.SewingModelId === "0099" &&
                                (product.SewingOrder.PreorderText.MountPositionId !== 4801 ||
                                  product.SewingOrder.PreorderText.MountPositionId === 4801) &&
                                product.SewingOrder.PreorderText.FabricDesignEn2 && (
                                  <div style={{ marginTop: "0.5rem" }}>
                                    <hr />
                                    <h1
                                      class="cart_agree_item_fabrics_sorted_title"
                                      style={{ marginTop: "0.2rem" }}
                                    >
                                      {t("Sheer")}
                                    </h1>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.FabricDesignEn &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" &&
                                product.SewingOrder.PreorderText.MountPositionId !== 4801 && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Material & Color")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.SewingOrder.PreorderText.FabricDesignFa2 +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorFa2
                                        : capitalizeFirstLetter(
                                            product.SewingOrder.PreorderText.FabricDesignEn2
                                          ) +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorEn2}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.FabricDesignEn2 &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" &&
                                product.SewingOrder.PreorderText.MountPositionId === 4801 && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Material & Color")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.SewingOrder.PreorderText.FabricDesignFa2 +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorFa2
                                        : capitalizeFirstLetter(
                                            product.SewingOrder.PreorderText.FabricDesignEn2
                                          ) +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorEn2}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.SheerHeaderStyle && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Header Style")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Grommet: "پانجی",
                                          "Standard Lining": "آستردوزی استاندارد",
                                          Right: "راست",
                                          "Inverted Box Pleat": "پلیسه",
                                          "Pencil Pleat": "ساده",
                                        }[product.SewingOrder.PreorderText.SheerHeaderStyle] ||
                                        product.SewingOrder.PreorderText.SheerHeaderStyle
                                      : product.SewingOrder.PreorderText.SheerHeaderStyle}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.PanelTypeB && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Panel Type")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          "Single Panel": "تک پنل، سمت چپ",
                                          "Standard Lining": "آستردوزی استاندارد",
                                          "Pair, Split Draw": "جفت پنل،دو طرف",
                                          "Single Panel, Right": "تک پنل، سمت راست",
                                        }[product.SewingOrder.PreorderText.PanelTypeB] ||
                                        product.SewingOrder.PreorderText.PanelTypeB
                                      : product.SewingOrder.PreorderText.PanelTypeB}
                                  </span>
                                </div>
                              )}

                              {product.SewingOrder.PreorderText.SheerHardware &&
                                product.SewingOrder.PreorderText.RailDesignEnB &&
                                product.SewingOrder.PreorderText.SheerHardware !== "None" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Hardware")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
                                            "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "I Have Others": "من چیز دیگری دارم",
                                            "I Have Motorized Track": "من تراک موتوری دارم",
                                            "I Have Track With Cord Draw": "من تراک اتومات دارم",
                                            "I Have Standard Track": "من تراک استاندارد دارم",
                                          }[product.SewingOrder.PreorderText.SheerHardware] ||
                                          [
                                            product.SewingOrder.PreorderText.SheerHardware ===
                                            "Track"
                                              ? "تراک"
                                              : product.SewingOrder.PreorderText.SheerHardware ===
                                                "Rod"
                                              ? "میله پردهِ"
                                              : null,
                                            product.SewingOrder.PreorderText.RailDesignFaB,
                                            product.SewingOrder.PreorderText.RailColorFaB,
                                            product.SewingOrder?.PreorderText?.BatonOptionB ===
                                            "Baton 30cm"
                                              ? "باتون ۳۰ س‌م"
                                              : product.SewingOrder?.PreorderText?.BatonOptionB ===
                                                "Baton 50cm"
                                              ? "باتون ۵۰ س‌م"
                                              : product.SewingOrder?.PreorderText?.BatonOptionB ===
                                                "None"
                                              ? "نیاز ندارم"
                                              : product.SewingOrder?.PreorderText?.BatonOptionB,
                                          ]
                                            .filter(
                                              (value) => value !== null && value !== undefined
                                            ) // حذف مقادیر نامعتبر
                                            .join(" / ")
                                        : [
                                            product.SewingOrder.PreorderText.SheerHardware,
                                            product.SewingOrder.PreorderText.RailDesignEnB,
                                            product.SewingOrder.PreorderText.RailColorEnB,
                                            product.SewingOrder.PreorderText.BatonOptionB,
                                          ]
                                            .filter(
                                              (value) => value !== null && value !== undefined
                                            ) // حذف مقادیر نامعتبر
                                            .join(" / ")}
                                    </span>
                                  </div>
                                )}

                              {product.SewingOrder.PreorderText.hardwareSheer &&
                                product.SewingOrder.PreorderText.hardwareSheer !== "None" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Hardware")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
                                            "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "I Have Others": "من چیز دیگری دارم",
                                            "I Have Motorized Track": "من تراک موتوری دارم",
                                            "I Have Standard Track": "من تراک استاندارد دارم",
                                            "I Have Track With Cord Draw": "من تراک اتومات دارم",
                                          }[product.SewingOrder.PreorderText.hardwareSheer] ||
                                          product.SewingOrder.PreorderText.hardwareSheer
                                        : product.SewingOrder.PreorderText.hardwareSheer}
                                    </span>
                                  </div>
                                )}

                              {(product.SewingOrder?.PreorderText?.SheerHardware ||
                                product.SewingOrder?.PreorderText?.RailDesignEnB ||
                                product.SewingOrder?.PreorderText?.RailColorEnB ||
                                product.SewingOrder?.PreorderText?.BatonOptionB) &&
                                product.SewingOrder.PreorderText.SheerHardware !== "None" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Hardware")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
                                            "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "I Have Others": "من چیز دیگری دارم",
                                            "I Have Motorized Track": "من تراک موتوری دارم",
                                            "I Have Standard Track": "من تراک استاندارد دارم",
                                            "I Have Track With Cord Draw": "من تراک اتومات دارم",
                                          }[product.SewingOrder.PreorderText.SheerHardware] ||
                                          product.SewingOrder.PreorderText.SheerHardware +
                                            "/" +
                                            product.SewingOrder.PreorderText.RailDesignEnB +
                                            "/" +
                                            product.SewingOrder.PreorderText.RailColorEnB +
                                            "/" +
                                            product.SewingOrder.PreorderText.BatonOptionB
                                        : product.SewingOrder.PreorderText.SheerHardware +
                                          "/" +
                                          product.SewingOrder.PreorderText.RailDesignEnB +
                                          "/" +
                                          product.SewingOrder.PreorderText.RailColorEnB +
                                          "/" +
                                          product.SewingOrder.PreorderText.BatonOptionB}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.HandCurtainNum2 && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Matching Tieback")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? `تعداد ${new Intl.NumberFormat("fa-IR").format(
                                          product.SewingOrder.PreorderText.HandCurtainNum2
                                        )}`
                                      : `Qty ${product.SewingOrder.PreorderText.HandCurtainNum2}`}
                                  </span>
                                </div>
                              )}

                              {product.SewingOrder.PreorderText.MotorPositionB && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Motor Position")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.MotorPositionB === "Right"
                                        ? "راست"
                                        : product.SewingOrder.PreorderText.MotorPositionB === "Left"
                                        ? "چپ"
                                        : product.SewingOrder.PreorderText.MotorPositionB
                                      : product.SewingOrder.PreorderText.MotorPositionB}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.RemoteNameB && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Remote Name")}</p>
                                  <span>{product.SewingOrder.PreorderText.RemoteNameB}</span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.MotorChannelsB && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Motor Channels")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.MotorChannelsB.join(
                                          ","
                                        ).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
                                      : product.SewingOrder.PreorderText.MotorChannelsB.join(",")}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.hasLead && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Lead Weight")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.hasLead === "Included"
                                        ? "دارد"
                                        : product.SewingOrder.PreorderText.hasLead === "True"
                                        ? "دارد"
                                        : product.SewingOrder.PreorderText.hasLead === "Right"
                                        ? "راست"
                                        : product.SewingOrder.PreorderText.hasLead === "Left"
                                        ? "چپ"
                                        : product.SewingOrder.PreorderText.hasLead
                                      : product.SewingOrder.PreorderText.hasLead}
                                  </span>
                                </div>
                              )}

                              {product.SewingOrder.PreorderText.SewingModelId === "0099" &&
                                (product.SewingOrder.PreorderText.MountPositionId !== 4801 ||
                                  product.SewingOrder.PreorderText.MountPositionId === 4801) &&
                                (product.SewingOrder.PreorderText.SheersDesignEn ||
                                  product.SheersDesignEn) && (
                                  <div style={{ marginTop: "0.5rem" }}>
                                    <hr />
                                    <h1
                                      class="cart_agree_item_fabrics_sorted_title"
                                      style={{ marginTop: "0.2rem" }}
                                    >
                                      {t("Privacy Layer")}
                                    </h1>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.FabricDesignEn3 &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Material & Color")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.SewingOrder.PreorderText.FabricDesignFa3 +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorFa3
                                        : capitalizeFirstLetter(
                                            product.SewingOrder.PreorderText.FabricDesignEn3
                                          ) +
                                          "/" +
                                          product.SewingOrder.PreorderText.FabricColorEn3}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.SheersDesignEn &&
                                product.SewingOrder.PreorderText.SewingModelId === "0099" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Material & Color")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? product.SewingOrder.PreorderText.SheersDesignFa +
                                          "/" +
                                          product.SewingOrder.PreorderText.SheersColorFa
                                        : capitalizeFirstLetter(
                                            product.SewingOrder.PreorderText.SheersDesignEn
                                          ) +
                                          "/" +
                                          product.SewingOrder.PreorderText.SheersColorEn}
                                    </span>
                                  </div>
                                )}
                              {product.SewingOrder.PreorderText.PrivacyLayerHeaderStyle && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Header Style")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Grommet: "پانجی",
                                          "Standard Lining": "آستردوزی استاندارد",
                                          Right: "راست",
                                          "Inverted Box Pleat": "پلیسه",
                                          "Pencil Pleat": "ساده",
                                        }[
                                          product.SewingOrder.PreorderText.PrivacyLayerHeaderStyle
                                        ] ||
                                        product.SewingOrder.PreorderText.PrivacyLayerHeaderStyle
                                      : product.SewingOrder.PreorderText.PrivacyLayerHeaderStyle}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.PanelTypeC && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Panel Type")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          "Single Panel": "تک پنل، سمت چپ",
                                          "Standard Lining": "آستردوزی استاندارد",
                                          "Pair, Split Draw": "جفت پنل،دو طرف",
                                        }[product.SewingOrder.PreorderText.PanelTypeC] ||
                                        product.SewingOrder.PreorderText.PanelTypeC
                                      : product.SewingOrder.PreorderText.PanelTypeC}
                                  </span>
                                </div>
                              )}

                              {product.SewingOrder.PreorderText.PrivacyLayerHardware &&
                                product.SewingOrder.PreorderText.SheersDesignEn &&
                                product.SewingOrder.PreorderText.PrivacyLayerHardware !==
                                  "None" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Hardware")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
                                            "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "I Have Others": "من چیز دیگری دارم",
                                            "I Have Motorized Track": "من تراک موتوری دارم",
                                            "I Have Track With Cord Draw": "من تراک اتومات دارم",
                                            "I Have Standard Track": "من تراک استاندارد دارم",
                                          }[
                                            product.SewingOrder.PreorderText.PrivacyLayerHardware
                                          ] ||
                                          [
                                            product?.SewingOrder.PreorderText
                                              .PrivacyLayerHardware === "Rod"
                                              ? "میله پردهِ"
                                              : product?.SewingOrder.PreorderText
                                                  .PrivacyLayerHardware === "Track"
                                              ? "تراک"
                                              : product?.SewingOrder.PreorderText
                                                  .PrivacyLayerHardware,
                                            pageLanguage === "fa"
                                              ? product?.SewingOrder.PreorderText.RailDesignFaC
                                              : product?.SewingOrder.PreorderText.RailDesignEnC,
                                            pageLanguage === "fa"
                                              ? product?.SewingOrder.PreorderText.RailColorFaC
                                              : product?.SewingOrder.PreorderText.RailColorEnC,
                                            pageLanguage === "fa"
                                              ? product?.SewingOrder.PreorderText.BatonOptionC ===
                                                "Baton 45cm"
                                                ? "باتون ۴۵ س‌م"
                                                : product?.SewingOrder.PreorderText.BatonOptionC ===
                                                  "Baton 30cm"
                                                ? "باتون ۳۰ س‌م"
                                                : product?.SewingOrder.PreorderText.BatonOptionC
                                              : product?.SewingOrder.PreorderText.BatonOptionC,
                                          ]
                                            .filter(
                                              (value) => value !== null && value !== undefined
                                            )
                                            .join(" / ")
                                        : [
                                            product?.SewingOrder.PreorderText.PrivacyLayerHardware,
                                            product?.SewingOrder.PreorderText.RailDesignEnC,
                                            product?.SewingOrder.PreorderText.RailColorEnC,
                                            product?.SewingOrder.PreorderText.BatonOptionC,
                                            product?.SewingOrder.PreorderText.BatonOptionC !==
                                              null &&
                                            product?.SewingOrder.PreorderText.BatonOptionC !==
                                              undefined
                                              ? product?.SewingOrder.PreorderText.ControlPositionC
                                              : null, // حذف ControlPositionC اگر BatonOptionC نامعتبر باشد
                                          ]
                                            .filter(
                                              (value) => value !== null && value !== undefined
                                            ) // حذف مقادیر نامعتبر
                                            .join(" / ")}
                                    </span>
                                  </div>
                                )}

                              {product.SewingOrder.PreorderText.hardwarePrivacyLayer &&
                                product.SewingOrder.PreorderText.hardwarePrivacyLayer !==
                                  "None" && (
                                  <div
                                    className={`lable_Details ${
                                      pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                    }`}
                                  >
                                    <p>{t("Hardware")}</p>
                                    <span>
                                      {pageLanguage === "fa"
                                        ? {
                                            "I Have 28mm Rod": "من میله پردهِ ۲۸ میل دارم",
                                            "I Have 25mm Rod": "من میله پردهِ ۲۵ میل دارم",
                                            "Standard Lining": "آستردوزی استاندارد",
                                            "I Have Others": "من چیز دیگری دارم",
                                            "I Have Motorized Track": "من تراک موتوری دارم",
                                            "I Have Standard Track": "من تراک استاندارد دارم",
                                            "I Have Track With Cord Draw": "من تراک اتومات دارم",
                                          }[
                                            product.SewingOrder.PreorderText.hardwarePrivacyLayer
                                          ] || product.SewingOrder.PreorderText.hardwarePrivacyLayer
                                        : product.SewingOrder.PreorderText.hardwarePrivacyLayer}
                                    </span>
                                  </div>
                                )}

                              {product.SewingOrder.PreorderText.MotorPositionC && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Motor Position")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.MotorPositionC === "Right"
                                        ? "راست"
                                        : product.SewingOrder.PreorderText.MotorPositionC === "Left"
                                        ? "چپ"
                                        : product.SewingOrder.PreorderText.MotorPositionC
                                      : product.SewingOrder.PreorderText.MotorPositionC}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.RemoteNameC && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Remote Name")}</p>
                                  <span>{product.SewingOrder.PreorderText.RemoteNameC}</span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.MotorChannelsC && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Motor Channels")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.MotorChannelsC.join(
                                          ","
                                        ).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
                                      : product.SewingOrder.PreorderText.MotorChannelsC.join(",")}
                                  </span>
                                </div>
                              )}
                              {product?.SewingOrder?.PreorderText?.SewingModelId === "0099" &&
                                product?.SewingOrder?.PreorderText?.Accessories?.some(
                                  (accessory) => accessory?.DesignNameEn
                                ) && (
                                  <div style={{ marginTop: "0.5rem" }}>
                                    <hr />
                                    <h1
                                      class="cart_agree_item_fabrics_sorted_title"
                                      style={{ marginTop: "0.2rem" }}
                                    >
                                      {t("Accessories")}
                                    </h1>
                                  </div>
                                )}

                              {product.SewingOrder.PreorderText.Accessories &&
                                product.SewingOrder.PreorderText.SewingModelId !== "0325" &&
                                product.SewingOrder.PreorderText.Accessories.map(
                                  (accessory, index) => {
                                    if (!accessory.DesignNameEn) {
                                      return null;
                                    }
                                    return (
                                      <div
                                        key={index}
                                        className={`lable_Details ${
                                          pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                        }`}
                                      >
                                        <p>
                                          {pageLanguage === "fa"
                                            ? accessory.DesignNameFa
                                            : accessory.DesignNameEn}
                                        </p>
                                        <span>
                                          {pageLanguage === "fa"
                                            ? `تعداد ${new Intl.NumberFormat("fa-IR").format(
                                                accessory.Qty
                                              )}`
                                            : `Qty ${accessory.Qty}`}
                                        </span>
                                      </div>
                                    );
                                  }
                                )}
                              {product.SewingOrder.PreorderText.ControlType && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Control Type")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.ControlType ===
                                        "Motorized / Standard"
                                        ? "برقی / استاندارد"
                                        : product.SewingOrder.PreorderText.ControlType ===
                                          "Continuous Loop"
                                        ? "دستی"
                                        : product.SewingOrder.PreorderText.ControlType ===
                                          "Motorized"
                                        ? "برقی"
                                        : product.SewingOrder.PreorderText.ControlType
                                      : product.SewingOrder.PreorderText.ControlType}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.MotorPosition && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Motor Position")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.MotorPosition === "Right"
                                        ? "راست"
                                        : product.SewingOrder.PreorderText.MotorPosition === "Left"
                                        ? "چپ"
                                        : product.SewingOrder.PreorderText.MotorPosition
                                      : product.SewingOrder.PreorderText.MotorPosition}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.RemoteName && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Remote Name")}</p>
                                  <span>{product.SewingOrder.PreorderText.RemoteName}</span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.MotorChannels && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Motor Channels")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.MotorChannels.join(
                                          ","
                                        ).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
                                      : product.SewingOrder.PreorderText.MotorChannels.join(",")}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.MetalValanceStyle && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Metal Valance Style")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? product.SewingOrder.PreorderText.MetalValanceStyle ===
                                        "MetalValance"
                                        ? "قاب فلزی"
                                        : product.SewingOrder.PreorderText.MetalValanceStyle ===
                                          "Left"
                                        ? "چپ"
                                        : product.SewingOrder.PreorderText.MetalValanceStyle
                                      : product.SewingOrder.PreorderText.MetalValanceStyle}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.MetalValanceColor && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Metal Valance Color")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Black: "سیاه",
                                          White: "سفید",
                                          Silver: "نقره ای",
                                        }[product.SewingOrder.PreorderText.MetalValanceColor] ||
                                        product.SewingOrder.PreorderText.MetalValanceColor
                                      : product.SewingOrder.PreorderText.MetalValanceColor}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.ControlPosition && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Control Position")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Right: "راست",
                                          Left: "چپ",
                                        }[product.SewingOrder.PreorderText.ControlPosition] ||
                                        product.SewingOrder.PreorderText.ControlPosition
                                      : product.SewingOrder.PreorderText.ControlPosition}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.ChainLength && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Chain Length")}</p>
                                  <span>
                                    {pageLanguage === "fa" ? (
                                      <>
                                        {new Intl.NumberFormat("fa-IR").format(
                                          product.SewingOrder.PreorderText.ChainLength
                                        )}
                                      </>
                                    ) : (
                                      <>{product.SewingOrder.PreorderText.ChainLength}</>
                                    )}
                                    <>{t("cm")}</>
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.RollType && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Control Position")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Standard: "استاندارد",
                                          Premium: "اعلا",
                                        }[product.SewingOrder.PreorderText.RollType] ||
                                        product.SewingOrder.PreorderText.RollType
                                      : product.SewingOrder.PreorderText.RollType}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.BracketType && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Bracket Type")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          "Round Edge": "گردگوشه",
                                          Left: "چپ",
                                        }[product.SewingOrder.PreorderText.BracketType] ||
                                        product.SewingOrder.PreorderText.BracketType
                                      : product.SewingOrder.PreorderText.BracketType}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.BracketColor && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Bracket Color")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          "Satin Brass": "طلایی خش‌دار",
                                          Left: "چپ",
                                        }[product.SewingOrder.PreorderText.BracketColor] ||
                                        product.SewingOrder.PreorderText.BracketColor
                                      : product.SewingOrder.PreorderText.BracketColor}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.HemStyle && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Hem Style")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Straight: "صاف",
                                          Left: "چپ",
                                          Wave: "مواج",
                                        }[product.SewingOrder.PreorderText.HemStyle] ||
                                        product.SewingOrder.PreorderText.HemStyle
                                      : product.SewingOrder.PreorderText.HemStyle}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.BottomBarStyle && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Bottom Bar Style")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          "Sewn-In": "دوخته شده داخل پارچه",
                                          Left: "چپ",
                                        }[product.SewingOrder.PreorderText.BottomBarStyle] ||
                                        product.SewingOrder.PreorderText.BottomBarStyle
                                      : product.SewingOrder.PreorderText.BottomBarStyle}
                                  </span>
                                </div>
                              )}
                              {product.SewingOrder.PreorderText.Features && (
                                <div
                                  className={`lable_Details ${
                                    pageLanguage === "fa" ? "lable_Details_rtl" : ""
                                  }`}
                                >
                                  <p>{t("Features")}</p>
                                  <span>
                                    {pageLanguage === "fa"
                                      ? {
                                          Standard: "استاندارد",
                                          Premium: "اعلا",
                                        }[product.SewingOrder.PreorderText.Features] ||
                                        product.SewingOrder.PreorderText.Features
                                      : product.SewingOrder.PreorderText.Features}
                                  </span>
                                </div>
                              )}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </>
                  ) : (
                    <>
                      <h4 className="checkout_item_room_name" style={{ padding: "0.1rem 0" }}></h4>
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <ContextAwareToggleViewDetails
                            eventKey="0"
                            textOnHide={t("View Details")}
                            textOnShow={t("Hide Details")}
                          />
                          <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                            <div className="basket_item_title_container 23">
                              <>
                                <span className="checkout_item_discount checkout_item_details_color">
                                  <span>{t("Color: ")}</span>
                                  {pageLanguage === "fa" ? product.ColorName : product.ColorEnName}
                                </span>
                                {product.ProductSizeName && (
                                  <h2 className="checkout_item_details checkout_item_details_design">
                                    <span>{t("Size: ")}</span>
                                    {pageLanguage === "fa"
                                      ? product.ProductSizeName
                                      : product.ProductSizeEnName}
                                  </h2>
                                )}

                                {product.ItemLength && (
                                  <h2 className="checkout_item_details checkout_item_details_design">
                                    <span>
                                      {pageLanguage === "fa" ? "طول: " : "Length: "}
                                      &nbsp;
                                    </span>
                                    {pageLanguage === "fa"
                                      ? product.ItemLength
                                      : product.ItemLength}
                                    <span> {t("CM")}</span>
                                  </h2>
                                )}
                                {product.Diameter && (
                                  <h2 className="checkout_item_details checkout_item_details_design">
                                    <span>{t("Diameter: ")}</span>
                                    {pageLanguage === "fa" ? product.Diameter : product.Diameter}
                                    <span> {t("MM")}</span>
                                  </h2>
                                )}
                              </>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </>
                  )}
                </>

                {product.Discount > 0 && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <img
                      src={require("../Images/public/discount1.svg").default}
                      className="img-fluid discount_applied_img"
                      alt=""
                    />

                    <span className="descount_price">
                      <span>
                        {pageLanguage === "fa"
                          ? product.DiscountCode || product.DiscountName
                          : product.DiscountCode || product.DiscountEnName}
                      </span>
                      <span style={{ padding: "0 2px" }}>
                        ({GetPrice(-product.Discount, pageLanguage, t("T"), isTabletOrMobile)})
                      </span>
                    </span>
                  </div>
                )}
              </div>
            </li>
          ))}
    </div>
  );
}
